import { cn } from "../../lib/cn";
import { severityIcon, type Severity } from "../primitives/chip";

export const sevStroke: Record<Severity, string> = {
  exploited: "var(--color-exploited)",
  high: "var(--color-high)",
  medium: "var(--color-medium)",
  low: "var(--color-low)",
  ok: "var(--color-ok)",
};
export const sevTextClass: Record<Severity, string> = { exploited: "text-exploited", high: "text-high", medium: "text-medium", low: "text-low", ok: "text-ok" };

/** Status ring (05 §4): colour + icon inside; pair with a text label. */
export function StatusRing({ severity, size = 40 }: { severity: Severity; size?: number }) {
  const Icon = severityIcon[severity];
  const r = size / 2 - 3;
  const c = 2 * Math.PI * r;
  const frac = severity === "ok" ? 1 : severity === "exploited" ? 0.25 : 0.6;
  return (
    <span aria-hidden className="relative inline-grid shrink-0 place-items-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--color-border)" strokeWidth="3" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={sevStroke[severity]} strokeWidth="3" strokeDasharray={`${c * frac} ${c}`} strokeLinecap="round" />
      </svg>
      <Icon className={cn("absolute", sevTextClass[severity])} style={{ width: size * 0.42, height: size * 0.42 }} strokeWidth={1.75} />
    </span>
  );
}
